export interface Money {
  currencyCode: string
  amount: number
}

export interface MoneyInput {
  currencyCode: string // ISO 4217 Three Letter String value
  amount: number
}

export interface Name {
  firstName: string
  lastName: string
}

export interface Address {
  line1: string
  line2?: string
  city: string
  region: string
  postalCode: string
  country: string
}

export interface PhoneNumber {
  countryPhoneCode: number
  phoneNumber: string
}

export interface PhoneNumberInput {
  countryPhoneCode: number
  phoneNumber: string
}

export enum ResidencyStatus {
  US_CITIZEN = 'US_CITIZEN',
  US_PERMANENT_RESIDENT = 'US_PERMANENT_RESIDENT',
  US_TEMPORARY_RESIDENT = 'US_TEMPORARY_RESIDENT',
  UNKNOWN = 'UNKNOWN',
}

// # ISO 3166-1 alpha-2 country codes
// # https://www.unicode.org/cldr/charts/47/supplemental/territory_information.html
export enum CountryCode {
  // """
  // Afghanistan
  // """
  AF = 'AF',

  // """
  // Åland Islands
  // """
  AX = 'AX',

  // """
  // Albania
  // """
  AL = 'AL',

  // """
  // Algeria
  // """
  DZ = 'DZ',

  // """
  // American Samoa
  // """
  AS = 'AS',

  // """
  // Andorra
  // """
  AD = 'AD',

  // """
  // Angola
  // """
  AO = 'AO',

  // """
  // Anguilla
  // """
  AI = 'AI',

  // """
  // Antarctica
  // """
  AQ = 'AQ',

  // """
  // Antigua & Barbuda
  // """
  AG = 'AG',

  // """
  // Argentina
  // """
  AR = 'AR',

  // """
  // Armenia
  // """
  AM = 'AM',

  // """
  // Aruba
  // """
  AW = 'AW',

  // """
  // Ascension Island
  // """
  AC = 'AC',

  // """
  // Australia
  // """
  AU = 'AU',

  // """
  // Austria
  // """
  AT = 'AT',

  // """
  // Azerbaijan
  // """
  AZ = 'AZ',

  // """
  // Bahamas
  // """
  BS = 'BS',

  // """
  // Bahrain
  // """
  BH = 'BH',

  // """
  // Bangladesh
  // """
  BD = 'BD',

  // """
  // Barbados
  // """
  BB = 'BB',

  // """
  // Belarus
  // """
  BY = 'BY',

  // """
  // Belgium
  // """
  BE = 'BE',

  // """
  // Belize
  // """
  BZ = 'BZ',

  // """
  // Benin
  // """
  BJ = 'BJ',

  // """
  // Bermuda
  // """
  BM = 'BM',

  // """
  // Bhutan
  // """
  BT = 'BT',

  // """
  // Bolivia
  // """
  BO = 'BO',

  // """
  // Bosnia & Herzegovina
  // """
  BA = 'BA',

  // """
  // Botswana
  // """
  BW = 'BW',

  // """
  // Bouvet Island
  // """
  BV = 'BV',

  // """
  // Brazil
  // """
  BR = 'BR',

  // """
  // British Indian Ocean Territory
  // """
  IO = 'IO',

  // """
  // British Virgin Islands
  // """
  VG = 'VG',

  // """
  // Brunei
  // """
  BN = 'BN',

  // """
  // Bulgaria
  // """
  BG = 'BG',

  // """
  // Burkina Faso
  // """
  BF = 'BF',

  // """
  // Burundi
  // """
  BI = 'BI',

  // """
  // Cambodia
  // """
  KH = 'KH',

  // """
  // Cameroon
  // """
  CM = 'CM',

  // """
  // Canada
  // """
  CA = 'CA',

  // """
  // Cape Verde
  // """
  CV = 'CV',

  // """
  // Caribbean Netherlands
  // """
  BQ = 'BQ',

  // """
  // Cayman Islands
  // """
  KY = 'KY',

  // """
  // Central African Republic
  // """
  CF = 'CF',

  // """
  // Ceuta & Melilla
  // """
  EA = 'EA',

  // """
  // Chad
  // """
  TD = 'TD',

  // """
  // Chile
  // """
  CL = 'CL',

  // """
  // China
  // """
  CN = 'CN',

  // """
  // Christmas Island
  // """
  CX = 'CX',

  // """
  // Clipperton Island
  // """
  CP = 'CP',

  // """
  // Cocos (Keeling) Islands
  // """
  CC = 'CC',

  // """
  // Colombia
  // """
  CO = 'CO',

  // """
  // Comoros
  // """
  KM = 'KM',

  // """
  // Congo - Brazzaville
  // """
  CG = 'CG',

  // """
  // Congo - Kinshasa
  // """
  CD = 'CD',

  // """
  // Cook Islands
  // """
  CK = 'CK',

  // """
  // Costa Rica
  // """
  CR = 'CR',

  // """
  // Côte d'Ivoire
  // """
  CI = 'CI',

  // """
  // Croatia
  // """
  HR = 'HR',

  // """
  // Cuba
  // """
  CU = 'CU',

  // """
  // Curaçao
  // """
  CW = 'CW',

  // """
  // Cyprus
  // """
  CY = 'CY',

  // """
  // Czechia
  // """
  CZ = 'CZ',

  // """
  // Denmark
  // """
  DK = 'DK',

  // """
  // Diego Garcia
  // """
  DG = 'DG',

  // """
  // Djibouti
  // """
  DJ = 'DJ',

  // """
  // Dominica
  // """
  DM = 'DM',

  // """
  // Dominican Republic
  // """
  DO = 'DO',

  // """
  // Ecuador
  // """
  EC = 'EC',

  // """
  // Egypt
  // """
  EG = 'EG',

  // """
  // El Salvador
  // """
  SV = 'SV',

  // """
  // Equatorial Guinea
  // """
  GQ = 'GQ',

  // """
  // Eritrea
  // """
  ER = 'ER',

  // """
  // Estonia
  // """
  EE = 'EE',

  // """
  // Eswatini
  // """
  SZ = 'SZ',

  // """
  // Ethiopia
  // """
  ET = 'ET',

  // """
  // Falkland Islands
  // """
  FK = 'FK',

  // """
  // Faroe Islands
  // """
  FO = 'FO',

  // """
  // Fiji
  // """
  FJ = 'FJ',

  // """
  // Finland
  // """
  FI = 'FI',

  // """
  // France
  // """
  FR = 'FR',

  // """
  // French Guiana
  // """
  GF = 'GF',

  // """
  // French Polynesia
  // """
  PF = 'PF',

  // """
  // French Southern Territories
  // """
  TF = 'TF',

  // """
  // Gabon
  // """
  GA = 'GA',

  // """
  // Gambia
  // """
  GM = 'GM',

  // """
  // Georgia
  // """
  GE = 'GE',

  // """
  // Germany
  // """
  DE = 'DE',

  // """
  // Ghana
  // """
  GH = 'GH',

  // """
  // Gibraltar
  // """
  GI = 'GI',

  // """
  // Greece
  // """
  GR = 'GR',

  // """
  // Greenland
  // """
  GL = 'GL',

  // """
  // Grenada
  // """
  GD = 'GD',

  // """
  // Guadeloupe
  // """
  GP = 'GP',

  // """
  // Guam
  // """
  GU = 'GU',

  // """
  // Guatemala
  // """
  GT = 'GT',

  // """
  // Guernsey
  // """
  GG = 'GG',

  // """
  // Guinea
  // """
  GN = 'GN',

  // """
  // Guinea-Bissau
  // """
  GW = 'GW',

  // """
  // Guyana
  // """
  GY = 'GY',

  // """
  // Haiti
  // """
  HT = 'HT',

  // """
  // Heard & McDonald Islands
  // """
  HM = 'HM',

  // """
  // Honduras
  // """
  HN = 'HN',

  // """
  // Hong Kong
  // """
  HK = 'HK',

  // """
  // Hungary
  // """
  HU = 'HU',

  // """
  // Iceland
  // """
  IS = 'IS',

  // """
  // India
  // """
  IN = 'IN',

  // """
  // Indonesia
  // """
  ID = 'ID',

  // """
  // Iran
  // """
  IR = 'IR',

  // """
  // Iraq
  // """
  IQ = 'IQ',

  // """
  // Ireland
  // """
  IE = 'IE',

  // """
  // Isle of Man
  // """
  IM = 'IM',

  // """
  // Israel
  // """
  IL = 'IL',

  // """
  // Italy
  // """
  IT = 'IT',

  // """
  // Jamaica
  // """
  JM = 'JM',

  // """
  // Japan
  // """
  JP = 'JP',

  // """
  // Jersey
  // """
  JE = 'JE',

  // """
  // Jordan
  // """
  JO = 'JO',

  // """
  // Kazakhstan
  // """
  KZ = 'KZ',

  // """
  // Kenya
  // """
  KE = 'KE',

  // """
  // Kiribati
  // """
  KI = 'KI',

  // """
  // Kosovo
  // """
  XK = 'XK',

  // """
  // Kuwait
  // """
  KW = 'KW',

  // """
  // Kyrgyzstan
  // """
  KG = 'KG',

  // """
  // Laos
  // """
  LA = 'LA',

  // """
  // Latvia
  // """
  LV = 'LV',

  // """
  // Lebanon
  // """
  LB = 'LB',

  // """
  // Lesotho
  // """
  LS = 'LS',

  // """
  // Liberia
  // """
  LR = 'LR',

  // """
  // Libya
  // """
  LY = 'LY',

  // """
  // Liechtenstein
  // """
  LI = 'LI',

  // """
  // Lithuania
  // """
  LT = 'LT',

  // """
  // Luxembourg
  // """
  LU = 'LU',

  // """
  // Macau
  // """
  MO = 'MO',

  // """
  // Madagascar
  // """
  MG = 'MG',

  // """
  // Malawi
  // """
  MW = 'MW',

  // """
  // Malaysia
  // """
  MY = 'MY',

  // """
  // Maldives
  // """
  MV = 'MV',

  // """
  // Mali
  // """
  ML = 'ML',

  // """
  // Malta
  // """
  MT = 'MT',

  // """
  // Marshall Islands
  // """
  MH = 'MH',

  // """
  // Martinique
  // """
  MQ = 'MQ',

  // """
  // Mauritania
  // """
  MR = 'MR',

  // """
  // Mauritius
  // """
  MU = 'MU',

  // """
  // Mayotte
  // """
  YT = 'YT',

  // """
  // Mexico
  // """
  MX = 'MX',

  // """
  // Micronesia
  // """
  FM = 'FM',

  // """
  // Moldova
  // """
  MD = 'MD',

  // """
  // Monaco
  // """
  MC = 'MC',

  // """
  // Mongolia
  // """
  MN = 'MN',

  // """
  // Montenegro
  // """
  ME = 'ME',

  // """
  // Montserrat
  // """
  MS = 'MS',

  // """
  // Morocco
  // """
  MA = 'MA',

  // """
  // Mozambique
  // """
  MZ = 'MZ',

  // """
  // Myanmar (Burma)
  // """
  MM = 'MM',

  // """
  // Namibia
  // """
  NA = 'NA',

  // """
  // Nauru
  // """
  NR = 'NR',

  // """
  // Nepal
  // """
  NP = 'NP',

  // """
  // Netherlands
  // """
  NL = 'NL',

  // """
  // New Caledonia
  // """
  NC = 'NC',

  // """
  // New Zealand
  // """
  NZ = 'NZ',

  // """
  // Nicaragua
  // """
  NI = 'NI',

  // """
  // Niger
  // """
  NE = 'NE',

  // """
  // Nigeria
  // """
  NG = 'NG',

  // """
  // Niue
  // """
  NU = 'NU',

  // """
  // Norfolk Island
  // """
  NF = 'NF',

  // """
  // North Korea
  // """
  KP = 'KP',

  // """
  // North Macedonia
  // """
  MK = 'MK',

  // """
  // Northern Mariana Islands
  // """
  MP = 'MP',

  // """
  // Norway
  // """
  NO = 'NO',

  // """
  // Oman
  // """
  OM = 'OM',

  // """
  // Pakistan
  // """
  PK = 'PK',

  // """
  // Palau
  // """
  PW = 'PW',

  // """
  // Palestine
  // """
  PS = 'PS',

  // """
  // Panama
  // """
  PA = 'PA',

  // """
  // Papua New Guinea
  // """
  PG = 'PG',

  // """
  // Paraguay
  // """
  PY = 'PY',

  // """
  // Peru
  // """
  PE = 'PE',

  // """
  // Philippines
  // """
  PH = 'PH',

  // """
  // Pitcairn Islands
  // """
  PN = 'PN',

  // """
  // Poland
  // """
  PL = 'PL',

  // """
  // Portugal
  // """
  PT = 'PT',

  // """
  // Puerto Rico
  // """
  PR = 'PR',

  // """
  // Qatar
  // """
  QA = 'QA',

  // """
  // Réunion
  // """
  RE = 'RE',

  // """
  // Romania
  // """
  RO = 'RO',

  // """
  // Russia
  // """
  RU = 'RU',

  // """
  // Rwanda
  // """
  RW = 'RW',

  // """
  // Samoa
  // """
  WS = 'WS',

  // """
  // San Marino
  // """
  SM = 'SM',

  // """
  // São Tomé & Príncipe
  // """
  ST = 'ST',

  // """
  // Saudi Arabia
  // """
  SA = 'SA',

  // """
  // Senegal
  // """
  SN = 'SN',

  // """
  // Serbia
  // """
  RS = 'RS',

  // """
  // Seychelles
  // """
  SC = 'SC',

  // """
  // Sierra Leone
  // """
  SL = 'SL',

  // """
  // Singapore
  // """
  SG = 'SG',

  // """
  // Sint Maarten
  // """
  SX = 'SX',

  // """
  // Slovakia
  // """
  SK = 'SK',

  // """
  // Slovenia
  // """
  SI = 'SI',

  // """
  // Solomon Islands
  // """
  SB = 'SB',

  // """
  // Somalia
  // """
  SO = 'SO',

  // """
  // South Africa
  // """
  ZA = 'ZA',

  // """
  // South Georgia & South Sandwich Islands
  // """
  GS = 'GS',

  // """
  // South Korea
  // """
  KR = 'KR',

  // """
  // South Sudan
  // """
  SS = 'SS',

  // """
  // Spain
  // """
  ES = 'ES',

  // """
  // Sri Lanka
  // """
  LK = 'LK',

  // """
  // St. Barthélemy
  // """
  BL = 'BL',

  // """
  // St. Helena
  // """
  SH = 'SH',

  // """
  // St. Kitts & Nevis
  // """
  KN = 'KN',

  // """
  // St. Lucia
  // """
  LC = 'LC',

  // """
  // St. Martin
  // """
  MF = 'MF',

  // """
  // St. Pierre & Miquelon
  // """
  PM = 'PM',

  // """
  // St. Vincent & Grenadines
  // """
  VC = 'VC',

  // """
  // Sudan
  // """
  SD = 'SD',

  // """
  // Suriname
  // """
  SR = 'SR',

  // """
  // Svalbard & Jan Mayen
  // """
  SJ = 'SJ',

  // """
  // Sweden
  // """
  SE = 'SE',

  // """
  // Switzerland
  // """
  CH = 'CH',

  // """
  // Syria
  // """
  SY = 'SY',

  // """
  // Taiwan
  // """
  TW = 'TW',

  // """
  // Tajikistan
  // """
  TJ = 'TJ',

  // """
  // Tanzania
  // """
  TZ = 'TZ',

  // """
  // Thailand
  // """
  TH = 'TH',

  // """
  // Timor-Leste
  // """
  TL = 'TL',

  // """
  // Togo
  // """
  TG = 'TG',

  // """
  // Tokelau
  // """
  TK = 'TK',

  // """
  // Tonga
  // """
  TO = 'TO',

  // """
  // Trinidad & Tobago
  // """
  TT = 'TT',

  // """
  // Tristan da Cunha
  // """
  TA = 'TA',

  // """
  // Tunisia
  // """
  TN = 'TN',

  // """
  // Turkey
  // """
  TR = 'TR',

  // """
  // Turkmenistan
  // """
  TM = 'TM',

  // """
  // Turks & Caicos Islands
  // """
  TC = 'TC',

  // """
  // Tuvalu
  // """
  TV = 'TV',

  // """
  // U.S. Outlying Islands
  // """
  UM = 'UM',

  // """
  // U.S. Virgin Islands
  // """
  VI = 'VI',

  // """
  // Uganda
  // """
  UG = 'UG',

  // """
  // Ukraine
  // """
  UA = 'UA',

  // """
  // United Arab Emirates
  // """
  AE = 'AE',

  // """
  // United Kingdom
  // """
  GB = 'GB',

  // """
  // United States
  // """
  US = 'US',

  // """
  // Uruguay
  // """
  UY = 'UY',

  // """
  // Uzbekistan
  // """
  UZ = 'UZ',

  // """
  // Vanuatu
  // """
  VU = 'VU',

  // """
  // Vatican City
  // """
  VA = 'VA',

  // """
  // Venezuela
  // """
  VE = 'VE',

  // """
  // Vietnam
  // """
  VN = 'VN',

  // """
  // Wallis & Futuna
  // """
  WF = 'WF',

  // """
  // Western Sahara
  // """
  EH = 'EH',

  // """
  // Yemen
  // """
  YE = 'YE',

  // """
  // Zambia
  // """
  ZM = 'ZM',

  // """
  // Zimbabwe
  // """
  ZW = 'ZW',
}
